import { toast } from "react-toastify";
import { _DisabilityCodes, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_md, MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { BasicTable, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../theme/Component/Modal";


export const DisabilityCodes = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_DisabilityCodes);

    const modal = useModal("", MODAL_md);
    const modalConfirm = useModal("Eliminar Dato", MODAL_SM);

    const getLista = () => {
        let props = {
            State: 1,
        }
        instance.getDisabilityCodesCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                setLista(resp)
            }
        ).catch(err => { toast.error(err) })
    }

    const create = () => {
        setBean({
            State: 1
        });
        modal.setModal({ ...modal.modal, view: true, name: "Crear Codigo de Incapacidad" });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
    }

    const editaItem = (obj: any) => {
        instance.updateDisabilityCodes(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalConfirm.close();
            }
        ).catch(err => {
            toast.error(err);
        });
    }
    
    const head = [
        { title: 'ID', property: 'IDDisabilityCodes', visible: true, mask: MASK_NUMBER },
        { title: 'Codigo', property: 'CodeDisability', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-fill', visible: _single.canEdit, evento: () => { modal.setModal({ ...modal.modal, view: true, name: "Editar Codigo" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalConfirm.open(); } },
        ]

        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    return (
        <BasicPage titulo="Codigos de Incapacidades">
            <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} />


            <ModalConfirm modal={modalConfirm.modal} updateModal={modalConfirm.setModal} eventModal={deleteItem}>
                <strong>Eliminar item</strong>
            </ModalConfirm>


            <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { editaItem(bean) }} >
                <div className="row">
                    <div className="col-md-12">
                        <label>Codigo</label>
                        <input type="text" value={bean.CodeDisability} onChange={(e) => { setBean({ ...bean, CodeDisability: e.target.value }) }} className="form-control" />
                    </div>
                    <div className="col-12">
                        <label>Descripción</label>
                        <textarea name="Description" className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, Description: e.target.value }) }} />
                    </div>
                </div>
            </Modal>
        </BasicPage>
    )
}